import React, { useState, useEffect } from 'react';
import { FormGroup, Label } from 'reactstrap';
import Tooltip from './Tooltip';
import { useFormContext, get } from "react-hook-form";
import './Formgroup.css'

type TextFieldProps = {
    name: string;
    label?: string;
    className?: string;
    type?: string;
    maxlength?: number;
    placeholder?: string;
    value?: string;
    defaultValue?: string;
    tooltipBody?: () => JSX.Element;
    minLength?: number;
    disabled?: boolean;
    required?: boolean;
    validation?: RegExp;
    readOnly?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    pasteNotAllowed?: boolean;
    css?: React.CSSProperties;
}
function TextField({ className, type, label, name, value, defaultValue, maxlength, placeholder, minLength, tooltipBody, disabled, required, validation, readOnly, css, onChange, pasteNotAllowed }: TextFieldProps) {
    const { register, formState: { errors } } = useFormContext();
    const [validations, setValidations] = useState({});
    const error = get(errors, name);

    useEffect(() => {
        setValidations({
            required: required,
            pattern: validation
        })
    }, [errors, validation, required]);

    const changePhoneValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length == 12 && !e.target.value.includes(" ")) {
            setValidations({ ...validations, pattern: new RegExp("([0-9],{11})")});
        }
        else {
            setValidations({ ...validations, pattern: validation });
        }
    }

    return (
        <>
            <FormGroup>
                {label && <Label htmlFor={name}>{label}</Label>}
                {tooltipBody &&
                    <Tooltip tooltipBody={tooltipBody()} />
                }
                <input {...register(name, validations)}
                    name={name}
                    className={className ? `form-control  ${className}` : 'form-control'}
                    type={'text'}
                    onChange={type === "phone" ? (e) => changePhoneValidation(e) : onChange}
                    value={value}
                    defaultValue={defaultValue}
                    maxLength={type == "phone" ? 12 : maxlength}
                    disabled={disabled}
                    placeholder={placeholder}
                    style={css}
                    onPaste={(e: any) =>  { pasteNotAllowed && e.preventDefault(); }}
                />
                <div className="form-error-wrapper">
                    {error?.type === 'required' && "This is a required field"}
                    {error?.type === 'minLength' && `This needs to be at least ${minLength} characters`}
                    {error?.type === 'pattern' && "This is not valid"}
                </div>
            </FormGroup>
        </>
    );
}
export default TextField;
